import RequirementDescription from "../../../../src/components/rms_resources_mgmt/RequirementDescription";
import RequirementRationale from "../../../../src/components/rms_resources_mgmt/RequirementRationale";
import RequirementReferText from "../../../../src/components/rms_resources_mgmt/RequirementReferText";
import * as React from 'react';
export default {
  RequirementDescription,
  RequirementRationale,
  RequirementReferText,
  React
};